// @ts-nocheck
import { useEffect, useRef } from 'react'
import { useRouter } from 'next/router'
import { applyInlineMobileVideoPlayback } from './applyInlineMobileVideoPlayback'

export const useAnchorNavigation = (html = null) => {
    const elementRef = useRef()
    const history = useRouter()
    const routeKey = history?.asPath
    useEffect(() => {
        const root = elementRef.current
        if (!root) {
            return
        }
        root.querySelectorAll('a').forEach((anchor) => {
            try {
                if (anchor.target || !anchor.href) {
                    return
                }
                const url = new URL(anchor.href)
                if (url.origin !== window.location.origin) {
                    return
                }
                const clickListener = (event) => {
                    event.preventDefault()
                    event.stopPropagation()
                    history.push(url.href.replace(url.origin, ''))
                }
                anchor.removeEventListener('click', clickListener)
                anchor.addEventListener('click', clickListener)
            } catch (e) {
                console.log(e)
            }
        })
        applyInlineMobileVideoPlayback(root)
        const timers = [150, 700].map((ms) =>
            setTimeout(() => applyInlineMobileVideoPlayback(root), ms)
        )
        return () => timers.forEach(clearTimeout)
    }, [html, routeKey])
    return elementRef
}
